
import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import { FaceMaterial } from "./materials/faceMaterial";


let faceMaterial: any;
let faceGroup: THREE.Group;
let faceBufferGeometry: ZapparThree.FaceBufferGeometry;
let faceTrackerGroup: ZapparThree.FaceAnchorGroup;

export function initFace(camera: any, renderer: THREE.WebGLRenderer, faceTracker: ZapparThree.FaceTracker, FaceTrackerGroup: ZapparThree.FaceAnchorGroup, faceTrackerForSmallerFace: THREE.Group) {
  faceTrackerGroup = FaceTrackerGroup;


  faceGroup = new THREE.Group();
  faceTrackerForSmallerFace.add(faceGroup)
  //let faceBufferGeometry = new THREE.CircleGeometry(0.5, 32, 0,  Math.PI*2);
  // new THREE.SphereGeometry( 1, 16, 16 );
  faceBufferGeometry = new ZapparThree.FaceBufferGeometry();

  faceMaterial = new FaceMaterial(
    camera,
    renderer,
    faceTracker,
    faceTrackerGroup,
    faceBufferGeometry
  )

  //const faceMesh = new ZapparThree.FaceMeshLoader(manager).load();
  let faceMesh = new THREE.Mesh(
    faceBufferGeometry,
    faceMaterial.texture
    //new THREE.MeshBasicMaterial({color: 0x0000ff})
  )
  faceMesh.scale.set(0.5, 0.5, 0.5)
  faceMesh.position.set(0, 0, 0)
  faceMesh.renderOrder = 2;
  faceGroup.add(faceMesh)


  //HEAD
  let faceSphere = new THREE.Mesh(
    new THREE.SphereGeometry(1, 16, 16),
    faceMaterial.texture
    //new THREE.MeshBasicMaterial({color: 0x00ff00})
  )

  faceSphere.position.set(0, 0.038, 0.05);
  faceSphere.scale.set(0.26, 0.38, 0.38)
  faceSphere.renderOrder = 1;
  faceGroup.add(faceSphere)

  //HEAD
  let faceSphere2 = new THREE.Mesh(
    new THREE.SphereGeometry(1, 16, 16),
    faceMaterial.texture
    //new THREE.MeshBasicMaterial({color: 0xff0000})
  )

  faceSphere2.position.set(0, 0.12, 0.15);
  faceSphere2.scale.set(0.28, 0.31, 0.31)
  faceSphere2.renderOrder = 1;
  faceGroup.add(faceSphere2)



  // //NECK
  // let faceCylinder = new THREE.Mesh(
  //   new THREE.CylinderGeometry( 0.15, 0.22, 0.3, 32 ),
  //   faceMaterial.texture
  //   //new THREE.MeshBasicMaterial({color: 0xff0000})
  // )

  // faceCylinder.position.set(0,-0.3,0);
  // faceCylinder.rotation.x = Math.PI/32;
  // faceCylinder.renderOrder = 1;
  // faceGroup.add(faceCylinder)


}


export function renderFace() {
  faceBufferGeometry.updateFromFaceAnchorGroup(faceTrackerGroup);
  faceMaterial?.render()
}

export function revealFace() {
  faceGroup.visible = true;
}

export function hideFace() {
  faceGroup.visible = false;
}